import { create } from 'zustand';
import type { UserProfile } from '@disenchantment/types';
import type { Session } from '@supabase/supabase-js';

interface AuthState {
  session: Session | null;
  user: UserProfile | null;
  loading: boolean;
  /** True while `logout()` is tearing down streams/socket before signOut. */
  signingOut: boolean;
  setSession: (session: Session | null) => void;
  setUser: (user: UserProfile | null) => void;
  setLoading: (loading: boolean) => void;
  setSigningOut: (signingOut: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  loading: true,
  signingOut: false,
  setSession: (session) => set({ session }),
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  setSigningOut: (signingOut) => set({ signingOut }),
  clear: () => set({ session: null, user: null, loading: false, signingOut: false }),
}));
